(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "google-map-react", "@material-ui/core/styles", "@thingsw/pitta-design-system", "lodash", "clsx", "@material-ui/icons/Check", "./TopRightControl", "@material-ui/icons/GpsFixed", "@material-ui/icons/Add", "@material-ui/icons/Remove", "@material-ui/core/useMediaQuery", "detect-browser", "@thingsw/pitta-modules", "../hoc/withStyleProvider"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("google-map-react"), require("@material-ui/core/styles"), require("@thingsw/pitta-design-system"), require("lodash"), require("clsx"), require("@material-ui/icons/Check"), require("./TopRightControl"), require("@material-ui/icons/GpsFixed"), require("@material-ui/icons/Add"), require("@material-ui/icons/Remove"), require("@material-ui/core/useMediaQuery"), require("detect-browser"), require("@thingsw/pitta-modules"), require("../hoc/withStyleProvider"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.googleMapReact, global.styles, global.pittaDesignSystem, global.lodash, global.clsx, global.Check, global.TopRightControl, global.GpsFixed, global.Add, global.Remove, global.useMediaQuery, global.detectBrowser, global.pittaModules, global.withStyleProvider);
    global.LocationMap = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _googleMapReact, _styles, _pittaDesignSystem, _lodash, _clsx5, _Check, _TopRightControl, _GpsFixed, _Add, _Remove, _useMediaQuery, _detectBrowser, _pittaModules, _withStyleProvider) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.LocationMap = void 0;
  _react = _interopRequireWildcard(_react);
  _googleMapReact = _interopRequireDefault(_googleMapReact);
  _lodash = _interopRequireDefault(_lodash);
  _clsx5 = _interopRequireDefault(_clsx5);
  _Check = _interopRequireDefault(_Check);
  _GpsFixed = _interopRequireDefault(_GpsFixed);
  _Add = _interopRequireDefault(_Add);
  _Remove = _interopRequireDefault(_Remove);
  _useMediaQuery = _interopRequireDefault(_useMediaQuery);
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
  function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
  var LocationWidth = 64;
  var LocationHeight = 73;
  var useStyles = (0, _styles.makeStyles)(function (theme) {
    var _camFilterDiv;
    return {
      rootFullscreen: {
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        zIndex: 9999,
        backgroundColor: "black"
      },
      topControlPane: _objectSpread(_objectSpread({
        position: "absolute",
        top: 0
      }, theme.direction === "rtl" ? {
        left: 0
      } : {
        right: 0
      }), {}, {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "visible"
      }),
      zoomControlDiv: _objectSpread(_objectSpread({
        position: "absolute",
        bottom: 0
      }, theme.direction === "rtl" ? {
        left: 0
      } : {
        right: 0
      }), {}, {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "visible",
        flexDirection: "column"
      }),
      zoomControlBtn: {
        borderRadius: 8,
        width: 30,
        height: 30,
        color: _pittaModules.LightColors.primary["3"],
        minHeight: 30
      },
      gpsFixBtn: {
        marginBottom: theme.spacing(0.5)
      },
      gpsFixBtnTouch: {
        color: "".concat(_pittaModules.LightColors.primary["7"], "!important")
      },
      noHover: {
        "&:hover": {
          fill: _pittaModules.LightColors.primary["3"],
          color: _pittaModules.LightColors.primary["3"]
        }
      },
      zoomInBtn: {
        borderBottom: 0,
        borderRadius: theme.spacing(1, 1, 0, 0),
        boxShadow: "none"
      },
      zoomOutBtn: {
        borderTop: 0,
        borderRadius: theme.spacing(0, 0, 1, 1),
        boxShadow: "none"
      },
      tnpDiv: _objectSpread({}, theme.direction === "rtl" ? {
        paddingRight: 44
      } : {
        paddingLeft: 44
      }),
      appIcon: _objectSpread({
        fontSize: 15,
        color: _pittaModules.LightColors.primary["1"]
      }, theme.direction === "rtl" ? {
        marginLeft: theme.spacing(1)
      } : {
        marginRight: theme.spacing(1)
      }),
      mobileMemuItem: {
        padding: theme.spacing(1.5, 2)
      },
      directionMakerIcon: {
        width: 20,
        height: 20,
        zIndex: 1
      },
      markerIcon: {
        cursor: "pointer",
        transform: "translate(-17px, -32px)",
        width: 34,
        height: 38,
        zIndex: 2
      },
      selectedMarkerIcon: {
        cursor: "pointer",
        transform: "translate(-19px, -38px)",
        width: 38,
        height: 42
      },
      startMarkerIcon: {
        zIndex: 2,
        transform: "translate(-12px, -12px)",
        filter: "drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.14)), drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.12)), drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.2))"
      },
      infoWindowDiv: {
        width: 300,
        backgroundColor: _pittaModules.LightColors.primary["0"],
        borderRadius: 4,
        border: "1px sloid ".concat(_pittaModules.LightColors.primary["6"])
      },
      privateCamDiv: {
        width: 120,
        padding: theme.spacing(1),
        backgroundColor: _pittaModules.LightColors.primary["0"],
        borderRadius: 4,
        border: "1px sloid ".concat(_pittaModules.LightColors.primary["6"]),
        display: "flex",
        alignItems: "center"
      },
      privateCamWindowCenter: {
        transform: "translate(-70px, calc(-100% - 20px))"
      },
      parkingDiv: {
        maxHeight: 421,
        boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      },
      infoWindowCenter: {
        transform: "translate(-150px, calc(-100% - 40px))"
      },
      inforParkingTitle: {
        padding: theme.spacing(1, 2),
        borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
      },
      textTransform: {
        textTransform: "none"
      },
      locationLabel: {
        backgroundColor: "white"
      },
      camFilterDiv: (_camFilterDiv = {
        minWidth: 311,
        padding: "0 16px"
      }, _defineProperty(_camFilterDiv, theme.breakpoints.down(430), {
        minWidth: 343
      }), _defineProperty(_camFilterDiv, theme.breakpoints.down(360), {
        minWidth: 311
      }), _defineProperty(_camFilterDiv, theme.breakpoints.down(330), {
        minWidth: 290
      }), _camFilterDiv),
      camFilterTitle: {
        margignBottom: 6.5,
        paddingBottom: 4,
        borderBottom: "2px solid ".concat(_pittaModules.LightColors.primary["9"])
      },
      camFilterListItem: {
        display: "flex",
        height: 48,
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 12,
        paddingRight: 5
      },
      camFilterRoot: {
        paddingTop: 15,
        paddingBottom: 7
      }
    };
  });
  var LocationMap = (0, _withStyleProvider.withStyleProvider)(function (props) {
    var _onGoogleApiLoaded = props.onGoogleApiLoaded,
      publicIcon = props.publicIcon,
      fullscreenIcon = props.fullscreenIcon,
      trackMarker = props.trackMarker,
      location = props.location,
      locations = props.locations,
      children = props.children,
      showHeading = props.showHeading,
      center = props.center,
      disableAutoZoom = props.disableAutoZoom,
      noMarker = props.noMarker,
      mode = props.mode,
      publicCams = props.publicCams,
      filteredCams = props.filteredCams,
      onSetInfoWindow = props.onSetInfoWindow,
      onUpdateBounds = props.onUpdateBounds,
      onLiveView = props.onLiveView,
      geofences = props.geofences,
      mapRef = props.mapRef,
      app = props.app,
      showLocation = props.showLocation,
      isPublic = props.isPublic,
      speedUnit = props.speedUnit,
      cameraState = props.cameraState,
      pushEventState = props.pushEventState,
      userState = props.userState,
      locationState = props.locationState,
      t = props.t;
    // useTraceUpdate(props);
    var classes = useStyles();
    var theme = (0, _styles.useTheme)();
    // const dispatch = useDispatch();
    var mobile = (0, _useMediaQuery["default"])(theme.breakpoints.down(_pittaModules.Webviewer.mobile));
    // const [gpsWS, readyState] = useGpsWS();

    var publicRef = (0, _react.useRef)(null);
    var anchorRef = (0, _react.useRef)(null);
    var mapDivRef = (0, _react.useRef)(null);
    var initialRequest = (0, _react.useRef)(true);
    var initialMyRequest = (0, _react.useRef)(true);
    // const initZoom = useRef(false);

    var clusters = cameraState.clusters,
      cameraList = cameraState.cameraList;
    var webPushEvent = pushEventState.webPushEvent;
    var email = userState.email,
      userSettings = userState.userSettings;
    var gpsWS = locationState.gpsWS,
      gpsWsReadyState = locationState.gpsWsReadyState;
    var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      map = _useState2[0],
      setMap = _useState2[1];
    var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      maps = _useState4[0],
      setMaps = _useState4[1];
    var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openLayer = _useState6[0],
      setOpenLayer = _useState6[1];
    var _useState7 = (0, _react.useState)("map"),
      _useState8 = _slicedToArray(_useState7, 2),
      mapMode = _useState8[0],
      setMapMode = _useState8[1];
    var _useState9 = (0, _react.useState)({}),
      _useState10 = _slicedToArray(_useState9, 2),
      markers = _useState10[0],
      setMarkers = _useState10[1];
    // const [gMarkers, setGMarkers] = useState<any[]>([]);
    var _useState11 = (0, _react.useState)(),
      _useState12 = _slicedToArray(_useState11, 2),
      bounds = _useState12[0],
      setBounds = _useState12[1];
    var _useState13 = (0, _react.useState)(),
      _useState14 = _slicedToArray(_useState13, 2),
      selectedMarker = _useState14[0],
      setSelectedMarker = _useState14[1];
    var _useState15 = (0, _react.useState)(),
      _useState16 = _slicedToArray(_useState15, 2),
      privateCamMarker = _useState16[0],
      setPrivateCamMarker = _useState16[1];
    var _useState17 = (0, _react.useState)(true),
      _useState18 = _slicedToArray(_useState17, 2),
      activePublic = _useState18[0],
      setActivePublic = _useState18[1];
    var _useState19 = (0, _react.useState)(false),
      _useState20 = _slicedToArray(_useState19, 2),
      openCamFilter = _useState20[0],
      setOpenCamFilter = _useState20[1];
    var prevLocation = (0, _react.useRef)();
    var locationMarker = (0, _react.useRef)();
    var gMarkers = (0, _react.useRef)([]);
    var publicMarkers = (0, _react.useRef)([]);
    var prevBounds = (0, _react.useRef)();
    var _useState21 = (0, _react.useState)(false),
      _useState22 = _slicedToArray(_useState21, 2),
      fullscreen = _useState22[0],
      setfullscreen = _useState22[1];
    var _useState23 = (0, _react.useState)(false),
      _useState24 = _slicedToArray(_useState23, 2),
      initMap = _useState24[0],
      setInitMap = _useState24[1];
    var _useState25 = (0, _react.useState)(false),
      _useState26 = _slicedToArray(_useState25, 2),
      touch = _useState26[0],
      setTouch = _useState26[1];
    var _useState27 = (0, _react.useState)(),
      _useState28 = _slicedToArray(_useState27, 2),
      hoveredLoc = _useState28[0],
      setHoveredLoc = _useState28[1];
    var smallMobileSize = (0, _useMediaQuery["default"])(theme.breakpoints.down(430));
    var xsmallMobileSize = (0, _useMediaQuery["default"])(theme.breakpoints.down(360));
    var iphoneSEMobileSize = (0, _useMediaQuery["default"])(theme.breakpoints.down(330));
    var iosBrowser = (0, _react.useMemo)(function () {
      var browser = (0, _detectBrowser.detect)();
      return (browser === null || browser === void 0 ? void 0 : browser.name) === "ios" || (browser === null || browser === void 0 ? void 0 : browser.name) === "crios";
    }, []);
    var geometries = (0, _react.useMemo)(function () {
      if (geofences) {
        return (0, _pittaModules.convertGeofenceToGeometries)(geofences);
      } else {
        return [];
      }
    }, [geofences]);

    // useEffect(() => {
    //   const load = () => {
    //     dispatch(loadUserSettings());
    //   };

    //   const timer = setTimeout(load, 1000);
    //   return () => {
    //     clearTimeout(timer);
    //   };
    // }, [dispatch]);

    (0, _react.useEffect)(function () {
      return function () {
        initialMyRequest.current = true;
      };
    }, []);
    (0, _react.useEffect)(function () {
      if (map && maps && geometries && geometries.length > 0) {
        var objects = (0, _pittaModules.renderGeofences)(map, maps, geometries, mobile, false);
        return function () {
          _lodash["default"].forEach(objects, function (o) {
            return o.setMap(null);
          });
        };
      }
    }, [geometries, map, maps, mobile]);
    var noCluster = (0, _react.useMemo)(function () {
      return clusters && !clusters.myzone && !clusters.zone;
    }, [clusters]);
    (0, _react.useEffect)(function () {
      // console.log(
      //   "LocationMap",
      //   "try to send gps websocket2",
      //   gpsWS,
      //   gpsWsReadyState,
      //   isPublic,
      //   cameraState,
      //   initialMyRequest.current
      // );
      if (email && gpsWS && gpsWsReadyState === WebSocket.OPEN && cameraList !== null && cameraList !== void 0 && cameraList.deviceListInfo && isPublic !== true && initialMyRequest.current) {
        // console.log(
        //   "LocationMap",
        //   "try to send gps websocket2",
        //   "gpsPsnsMyDevices",
        //   "isPublic",
        //   isPublic
        // );
        initialMyRequest.current = false;
        var msg = {
          action: "gpsPsnsMyDevices",
          email: email,
          sequenceId: new Date().getTime()
        };
        gpsWS.send(JSON.stringify(msg));
      }
    }, [email, gpsWS, gpsWsReadyState, cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, isPublic]);
    (0, _react.useEffect)(function () {
      // 나의 대시캠 위치를 요청하였으나, 위치가 없는 경우, 현재 지도 상의 대시캠 요청
      if (initialRequest.current && initialMyRequest.current === false && noCluster && locations && locations.length === 0 && bounds && mode !== "liveview") {
        if (email && gpsWsReadyState === WebSocket.OPEN) {
          if (!(bounds.south === bounds.north || bounds.west === bounds.east)) {
            initialRequest.current = false;
            // const msg: GPSMessage = {
            //   action: "gpsZoneAllDevices",
            //   email,
            //   sw: `${bounds.south}_${bounds.west}`,
            //   ne: `${bounds.north}_${bounds.east}`,
            //   sequenceId: new Date().getTime(),
            // };
            // gpsWS?.send(JSON.stringify(msg));
            // mantis - 11683, mycam 위치 이동하지 않는 이슈 수정 gpsZoneGroupAllDevices(Leehj)
            if (cameraList !== null && cameraList !== void 0 && cameraList.deviceListInfo) {
              var groupIdList = _lodash["default"].map(cameraList.deviceListInfo.filter(function (c) {
                return c.groupManagementID !== undefined;
              }), function (c) {
                return c.groupManagementID;
              });
              var stringGroupIdList = groupIdList.filter(function (id) {
                return typeof id === "string";
              });
              stringGroupIdList.push("allcameranotingroup");
              var groupMsg = {
                action: "gpsZoneGroupAllDevices",
                email: email,
                sw: "".concat(bounds.south, "_").concat(bounds.west),
                ne: "".concat(bounds.north, "_").concat(bounds.east),
                groupIdList: stringGroupIdList,
                sequenceId: new Date().getTime()
              };
              gpsWS === null || gpsWS === void 0 ? void 0 : gpsWS.send(JSON.stringify(groupMsg));
            }
          }
        }
      }
    }, [bounds, cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, email, gpsWS, gpsWsReadyState, locations, mode, noCluster]);
    var getSVGIcon = (0, _react.useCallback)(function (loc, isEvent, isPublic, hideName, liveview, shadow) {
      var heading = loc.heading;
      var width = LocationWidth;
      var height = LocationHeight;
      var markerFill = _pittaModules.LightColors.primary["7"].replace("#", "%23");
      var markerStroke = _pittaModules.LightColors.primary["0"].replace("#", "%23");
      var arrowStroke = "%23E9E9EA";
      var offsetScale = 1;
      // if (loc.active === "off") {
      //   markerColor = LightColors.primary["3"].replace("#", "%23");
      // }

      var camSvg = "\n      <rect x=\"38\" y=\"2\" width=\"22\" height=\"14\" rx=\"5\" fill=\"%233C3C3C\" stroke=\"white\" stroke-width=\"2\"/>\n      <circle cx=\"45\" cy=\"9\" r=\"2\" stroke=\"white\" stroke-width=\"2\"/>\n      <circle cx=\"59\" cy=\"4\" r=\"3\" fill=\"%23DF434D\" stroke=\"white\" stroke-width=\"2\"/>\n      ";
      // 10487 - 라이브뷰에서 대시캠 아이콘 표시
      if (isPublic || loc.active === "off") {
        camSvg = "";
      }
      var markerSvg = "\n        <path d=\"M25 35C25 33.1814 25.7375 31.4372 27.0503 30.1513C28.363 28.8653 30.1435 28.1429 32 28.1429C33.8565 28.1429 35.637 28.8653 36.9497 30.1513C38.2625 31.4372 39 33.1814 39 35H25ZM32 27.2857C29.0994 27.2857 26.75 24.9843 26.75 22.1429C26.75 19.3014 29.0994 17 32 17C34.9006 17 37.25 19.3014 37.25 22.1429C37.25 24.9843 34.9006 27.2857 32 27.2857Z\" fill=\"white\"/>\n      ";
      if (loc.mode === "1" && loc.active === "on") {
        markerSvg = "<path d=\"M32.6869 28.4248H28.7016V25.9111H32.6869C33.3028 25.9111 33.8041 25.8109 34.1908 25.6104C34.5776 25.4027 34.8604 25.1162 35.0395 24.751C35.2185 24.3857 35.308 23.974 35.308 23.5156C35.308 23.0501 35.2185 22.6169 35.0395 22.2158C34.8604 21.8148 34.5776 21.4925 34.1908 21.249C33.8041 21.0055 33.3028 20.8838 32.6869 20.8838H29.8188V34H26.5961V18.3594H32.6869C33.9115 18.3594 34.9607 18.5814 35.8344 19.0254C36.7153 19.4622 37.3884 20.0674 37.8539 20.8408C38.3194 21.6143 38.5522 22.4987 38.5522 23.4941C38.5522 24.5039 38.3194 25.3776 37.8539 26.1152C37.3884 26.8529 36.7153 27.4222 35.8344 27.8232C34.9607 28.2243 33.9115 28.4248 32.6869 28.4248Z\" fill=\"white\"/>";
      } else if (isPublic) {
        markerSvg = "";
      }
      if (loc.active === "off") {
        markerFill = "%2368686E";
      }
      if (isEvent) {
        markerFill = _pittaModules.LightColors.secondary["11"].replace("#", "%23");
      }
      if (isPublic) {
        markerFill = _pittaModules.LightColors.primary["0"].replace("#", "%23");
        if (loc.share_video === "on") {
          markerStroke = _pittaModules.LightColors.secondary["11"].replace("#", "%23");
          arrowStroke = _pittaModules.LightColors.secondary["11"].replace("#", "%23");
        }
      }
      var arrowYOffset = -7;
      height = 66 * offsetScale;
      if (!hideName && loc.mode === "0" && loc.active === "on") {
        height = 77 * offsetScale;
        arrowYOffset = 4;
      }
      var arrowMarkup = "<g style=\"transform:translate(0,".concat(arrowYOffset, "px)\">\n      <path d=\"M32.3838 72.2926C32.1995 72.5691 31.8005 72.5691 31.6162 72.2926L27.5822 66.2414C27.367 65.9186 27.6024 65.5 27.966 65.5L36.034 65.5C36.3976 65.5 36.633 65.9186 36.4178 66.2414L32.3838 72.2926Z\" fill=\"").concat(markerStroke, "\" stroke=\"").concat(arrowStroke, "\"/>\n      </g>");
      var directionMarkup = "";
      var offset = 64 * (offsetScale - 1) / 2;
      if (loc.mode === "0" && showHeading && heading !== undefined && !isNaN(heading)) {
        directionMarkup = "\n        <g  style=\"transform-origin: 19px 40px; transform:translate(13px, ".concat(-10 + offset / 2, "px) rotate(").concat(heading, "deg);\">\n\n<path opacity=\"0.85\" d=\"M19 40L9.00003 34.5L3.01998e-05 4.30733e-06L38 3.8147e-06L29 34.5L19 40Z\" fill=\"url(%23paint0_linear_4980_10633)\"/>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_4980_10633\" x1=\"19\" y1=\"40\" x2=\"19\" y2=\"-6.66667\" gradientUnits=\"userSpaceOnUse\">\n<stop offset=\"0.238239\" stop-color=\"%230095E0\"/>\n<stop offset=\"0.833168\" stop-color=\"%230095E0\" stop-opacity=\"0\"/>\n</linearGradient>\n</defs>\n\n        ");
      }
      if (liveview) {
        arrowMarkup = "";
      }
      var background = "<path d=\"M37.2773 49.418C47.9932 47.0137 56 37.4419 56 26C56 12.7452 45.2549 2 32 2C18.7451 2 8 12.7452 8 26C8 37.5896 16.2148 47.2606 27.1396 49.5076C27.1494 49.5247 27.1602 49.5418 27.1719 49.5587L31.3555 55.7687C31.752 56.3571 32.6172 56.3571 33.0137 55.7687L37.1973 49.5587C37.2285 49.5128 37.2549 49.4658 37.2773 49.418Z\" fill=\"".concat(markerStroke, "\"/>");
      if (isPublic) {
        background = "<g style=\"transform:translate(-2px, 0)\">\n        <path d=\"M39.3886 49.4957L39.1502 49.5487L39.0455 49.7694C39.0326 49.7965 39.0182 49.8219 39.0016 49.8461L39.0002 49.8481L34.6423 56.2631C34.4277 56.579 33.9568 56.579 33.7422 56.2631C33.7422 56.2631 33.7422 56.2631 33.7422 56.2631L29.3843 49.8481L29.3843 49.848L29.3804 49.8424C29.3764 49.8367 29.3733 49.8318 29.3709 49.8276L29.2585 49.6315L29.0371 49.5863C17.8824 47.3111 9.5 37.5196 9.5 25.7925C9.5 12.38 20.465 1.5 34 1.5C47.535 1.5 58.5 12.38 58.5 25.7925C58.5 37.3701 50.3299 47.0611 39.3886 49.4957Z\" fill=\"".concat(markerStroke, "\" stroke=\"").concat(arrowStroke, "\"/>\n        </g>");
      }
      // console.log(
      //   "getSVGIcon",
      //   loc,
      //   "isEvent",
      //   isEvent,
      //   "isPublic",
      //   isPublic,
      //   "hideName",
      //   hideName,
      //   "height",
      //   height,
      //   "width",
      //   width,
      //   "liveview",
      //   liveview,
      //   "markerSvg",
      //   markerSvg,
      //   "arrowMarkup",
      //   arrowMarkup
      // );

      width = 64 * offsetScale;
      var scale = 1 / offsetScale;
      if (liveview) {
        scale = 0.56 / offsetScale;
      }
      return {
        width: width,
        height: height,
        svg: "data:image/svg+xml;utf-8,\n        <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"", 0, " ", 0, " ").concat(width, " ").concat(height, "\" fill=\"none\" data-psn=\"").concat(loc.psn, "\" xmlns=\"http://www.w3.org/2000/svg\" style=\"transform:translate(-", 0, "px,0px)\">\n        \n        ").concat(directionMarkup, " \n\n        <g style=\"transform-origin:50% 50%;transform:scale(").concat(scale, ")\">\n          ").concat(arrowMarkup, "\n          \n          ").concat(background, "\n\n\n          <circle cx=\"32\" cy=\"26\" r=\"21\" fill=\"").concat(markerFill, "\"/>\n          ").concat(markerSvg, "\n          <g style=\"transform-origin:90% 40%;transform:scale(").concat(liveview ? 1.54 : 1, ")\">\n            ").concat(camSvg, "  \n          </g>\n          \n          <g clip-path=\"url(%23clip0_3821_95343)\">\n            <path d=\"M0 40H64V66H0V40Z\" fill=\"white\"/>\n          </g>\n          <defs>\n            <clipPath id=\"clip0_3821_95343\">\n            </clipPath>\n          </defs>\n        </g>\n        <filter id=\"filter0_ddddd_3821_96320\" x=\"0\" y=\"0\" width=\"").concat(width, "\" height=\"").concat(height, "\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_3821_96320\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"0.5\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"/>\n<feBlend mode=\"normal\" in2=\"effect1_dropShadow_3821_96320\" result=\"effect2_dropShadow_3821_96320\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"1\"/>\n<feGaussianBlur stdDeviation=\"0.5\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0\"/>\n<feBlend mode=\"normal\" in2=\"effect2_dropShadow_3821_96320\" result=\"effect3_dropShadow_3821_96320\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"3\"/>\n<feGaussianBlur stdDeviation=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0\"/>\n<feBlend mode=\"normal\" in2=\"effect3_dropShadow_3821_96320\" result=\"effect4_dropShadow_3821_96320\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"6\"/>\n<feGaussianBlur stdDeviation=\"1\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0\"/>\n<feBlend mode=\"normal\" in2=\"effect4_dropShadow_3821_96320\" result=\"effect5_dropShadow_3821_96320\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect5_dropShadow_3821_96320\" result=\"shape\"/>\n</filter>\n        </svg>")
      };
    }, [showHeading]);
    (0, _react.useEffect)(function () {
      if (bounds) {
        onUpdateBounds === null || onUpdateBounds === void 0 ? void 0 : onUpdateBounds(bounds);
      }
    }, [bounds, onUpdateBounds]);
    (0, _react.useEffect)(function () {
      if (mode === "liveview" && center && map) {
        var lat = center.lat,
          lng = center.lng;
        if (lat && lng) {
          map.setCenter({
            lat: lat,
            lng: lng
          });
        }
      } else if (center && map && prevBounds.current === undefined) {
        //메인 지도 화면에서 카메라 선택시 이동하는 로직
        prevBounds.current = map.getBounds();
        var zoom = center.zoom,
          _lat = center.lat,
          _lng = center.lng;
        if (_lat && _lng) {
          map.setCenter({
            lat: _lat,
            lng: _lng
          });
        }
        if (zoom && map.getZoom() <= zoom) {
          map.setZoom(zoom);
        }
      } else if (map && center === undefined && prevBounds.current) {
        //메인 지도 화면에서 상세보기에서 빠져나오는 경우
        // map.fitBounds(prevBounds.current);
        prevBounds.current = undefined;
      }
    }, [center, map, mode]);
    (0, _react.useEffect)(function () {
      function exitHandler() {
        if (!document.fullscreenElement &&
        //@ts-ignore
        !document.webkitIsFullScreen &&
        //@ts-ignore
        !document.mozFullScreen &&
        //@ts-ignore
        !document.msFullscreenElement) {
          ///fire your event
          setfullscreen(false);
        }
      }
      document.addEventListener("fullscreenchange", exitHandler);
      document.addEventListener("webkitfullscreenchange", exitHandler);
      document.addEventListener("mozfullscreenchange", exitHandler);
      document.addEventListener("MSFullscreenChange", exitHandler);
      return function () {
        document.removeEventListener("fullscreenchange", exitHandler);
        document.removeEventListener("webkitfullscreenchange", exitHandler);
        document.removeEventListener("mozfullscreenchange", exitHandler);
        document.removeEventListener("MSFullscreenChange", exitHandler);
      };
    }, []);
    (0, _react.useEffect)(function () {
      if (map && mode !== "liveview" && maps && activePublic && noCluster) {
        _lodash["default"].forEach(publicCams, function (cam, indx) {
          if (cam.active === "off") {
            return;
          }
          var loc = {
            lat: cam.lat,
            lng: cam.lng,
            heading: 0,
            psn: cam.psn,
            name: cam.dev_name,
            speed: cam.speed,
            share_video: cam.share_video,
            mode: cam.mode,
            active: cam.active,
            profile_img: cam.profile_img,
            share_dev_name: cam.share_dev_name,
            isPublic: true
          };
          var current = publicMarkers.current;
          var found = _lodash["default"].find(current, function (marker) {
            return marker.psn === cam.psn;
          });
          var labelText = (0, _pittaModules.getLocationLabel)(loc, speedUnit !== null && speedUnit !== void 0 ? speedUnit : userSettings === null || userSettings === void 0 ? void 0 : userSettings.velocityUnit, loc.share_dev_name === "off");
          if (found) {
            var _found$label, _found$label2, _found$profile, _found$profile2;
            var _getSVGIcon = getSVGIcon(loc, false, true, loc.share_dev_name === "off", false, loc.psn === (hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn)),
              width = _getSVGIcon.width,
              height = _getSVGIcon.height,
              svg = _getSVGIcon.svg;
            found.main.setPosition({
              lat: cam.lat,
              lng: cam.lng
            });
            found.main.setIcon({
              anchor: new maps.Point(width / 2, height),
              size: new maps.Size(width, height),
              scaledSize: new maps.Size(width, height),
              url: svg
            });
            var labelWidth = labelText.width,
              labelHeight = labelText.height,
              single = labelText.single,
              labelSvg = labelText.svg;
            (_found$label = found.label) === null || _found$label === void 0 ? void 0 : _found$label.setPosition({
              lat: cam.lat,
              lng: cam.lng
            });
            var labelIcon = (_found$label2 = found.label) === null || _found$label2 === void 0 ? void 0 : _found$label2.getIcon();
            if (labelIcon) {
              var _found$label3;
              labelIcon.anchor = new maps.Point(labelWidth / 2, single ? 26 : 36);
              labelIcon.size = new maps.Size(labelWidth, labelHeight);
              labelIcon.scaledSize = new maps.Size(labelWidth, labelHeight);
              labelIcon.url = labelSvg;
              (_found$label3 = found.label) === null || _found$label3 === void 0 ? void 0 : _found$label3.setIcon(labelIcon);
            }
            (_found$profile = found.profile) === null || _found$profile === void 0 ? void 0 : _found$profile.setPosition({
              lat: cam.lat,
              lng: cam.lng
            });
            var profileIcon = (_found$profile2 = found.profile) === null || _found$profile2 === void 0 ? void 0 : _found$profile2.getIcon();
            if (profileIcon) {
              var _found$profile3;
              profileIcon.anchor = new maps.Point(21, single ? 60.5 : 70.5);
              (_found$profile3 = found.profile) === null || _found$profile3 === void 0 ? void 0 : _found$profile3.setIcon(profileIcon);
            }
            // found.profile?.setIcon({
            //   ...profileIcon,
            //   anchor: new maps.Point(21, single ? 60.5 : 70.5),
            // });
          } else {
            var _profile3, _profile4;
            var label;
            var profile;
            if (labelText) {
              var _labelWidth = labelText.width,
                _labelHeight = labelText.height,
                _single = labelText.single,
                _svg = labelText.svg;
              label = new maps.Marker({
                position: {
                  lat: cam.lat,
                  lng: cam.lng
                },
                map: map,
                zIndex: cam.share_video === "on" ? 50000 + indx * 3 + 2 : 10000 + indx * 3 + 2,
                icon: {
                  origin: new maps.Point(0, 0),
                  anchor: new maps.Point(_labelWidth / 2, _single ? 26 : 36),
                  size: new maps.Size(_labelWidth, _labelHeight),
                  scaledSize: new maps.Size(_labelWidth, _labelHeight),
                  url: _svg
                }
              });
              profile = new maps.Marker({
                position: {
                  lat: cam.lat,
                  lng: cam.lng
                },
                map: map,
                zIndex: cam.share_video === "on" ? 50000 + indx * 3 + 1 : 10000 + indx * 3 + 1,
                icon: {
                  origin: new maps.Point(0, 0),
                  size: new maps.Size(42, 42),
                  scaledSize: new maps.Size(42, 42),
                  anchor: new maps.Point(21, _single ? 60.5 : 70.5),
                  url: cam.profile_img
                },
                title: "profile"
              });
            }
            var _getSVGIcon2 = getSVGIcon(loc, false, true, loc.share_dev_name === "off", false, loc.psn === (hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn)),
              _width = _getSVGIcon2.width,
              _height = _getSVGIcon2.height,
              _svg2 = _getSVGIcon2.svg;
            var marker = new maps.Marker({
              //mantis - 8558 , 클릭한 카메라의 psn을 위한 추가
              psn: loc.psn,
              position: {
                lat: cam.lat,
                lng: cam.lng
              },
              map: map,
              zIndex: cam.share_video === "on" ? 50000 + indx * 3 : 10000 + indx * 3,
              icon: {
                anchor: new maps.Point(_width / 2, _height),
                size: new maps.Size(_width, _height),
                scaledSize: new maps.Size(_width, _height),
                url: _svg2
              }
            });
            if (loc.active === "on") {
              if (loc.share_video === "on") {
                var _profile;
                marker.addListener("click", function () {
                  onLiveView === null || onLiveView === void 0 ? void 0 : onLiveView(cam.psn, true);
                });
                (_profile = profile) === null || _profile === void 0 ? void 0 : _profile.addListener("click", function () {
                  onLiveView === null || onLiveView === void 0 ? void 0 : onLiveView(cam.psn, true);
                });
              } else {
                var _profile2;
                marker.addListener("click", function () {
                  setPrivateCamMarker(marker);
                });
                (_profile2 = profile) === null || _profile2 === void 0 ? void 0 : _profile2.addListener("click", function () {
                  setPrivateCamMarker(marker);
                });
              }
            }
            (_profile3 = profile) === null || _profile3 === void 0 ? void 0 : _profile3.addListener("mouseover", function () {
              console.log("mouseover");
              setHoveredLoc(loc);
            });
            (_profile4 = profile) === null || _profile4 === void 0 ? void 0 : _profile4.addListener("mouseout", function () {
              console.log("mouseout");
              setHoveredLoc(undefined);
            });
            publicMarkers.current.push({
              main: marker,
              label: label,
              profile: profile,
              psn: cam.psn
            });
          }
        });
      } else {
        _lodash["default"].forEach(publicMarkers.current, function (m) {
          var _m$profile, _m$label;
          m.main.setMap(null);
          (_m$profile = m.profile) === null || _m$profile === void 0 ? void 0 : _m$profile.setMap(null);
          (_m$label = m.label) === null || _m$label === void 0 ? void 0 : _m$label.setMap(null);
        });
        publicMarkers.current = [];
      }
    }, [activePublic, getSVGIcon, hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn, map, maps, mode, noCluster, onLiveView, publicCams, speedUnit, userSettings]);
    (0, _react.useEffect)(function () {
      if (map && maps) {
        var initZoom = mode === "liveview" ? 15 : 17;
        var idleListener = map.addListener("idle", function () {
          var newBounds = map.getBounds().toJSON();
          if (!_lodash["default"].isEqual(bounds, newBounds) && !isNaN(newBounds.south)) {
            setBounds(newBounds);

            // console.log(
            //   "CloudNative3",
            //   "LocationMap",
            //   "newBounds",
            //   newBounds,
            //   "s/n",
            //   newBounds.south === newBounds.north,
            //   "w/e",
            //   newBounds.west === newBounds.east
            // );

            console.log("LocationMap", "try to send gps websocket3", gpsWS, gpsWsReadyState);
            if (email && gpsWsReadyState === WebSocket.OPEN) {
              if (mode !== "liveview" && !location) {
                if (!(newBounds.south === newBounds.north || newBounds.west === newBounds.east)) {
                  // const msg: GPSMessage = {
                  //   action: "gpsZoneAllDevices",
                  //   email,
                  //   sw: `${newBounds.south}_${newBounds.west}`,
                  //   ne: `${newBounds.north}_${newBounds.east}`,
                  //   sequenceId: new Date().getTime(),
                  // };
                  // gpsWS?.send(JSON.stringify(msg));

                  // mantis - 11683, mycam 위치 이동하지 않는 이슈 수정 gpsZoneGroupAllDevices(Leehj)
                  if (cameraList !== null && cameraList !== void 0 && cameraList.deviceListInfo) {
                    var groupIdList = _lodash["default"].map(cameraList.deviceListInfo.filter(function (c) {
                      return c.groupManagementID !== undefined;
                    }), function (c) {
                      return c.groupManagementID;
                    });
                    var stringGroupIdList = groupIdList.filter(function (id) {
                      return typeof id === "string";
                    });
                    stringGroupIdList.push("allcameranotingroup");
                    var groupMsg = {
                      action: "gpsZoneGroupAllDevices",
                      email: email,
                      sw: "".concat(newBounds.south, "_").concat(newBounds.west),
                      ne: "".concat(newBounds.north, "_").concat(newBounds.east),
                      groupIdList: stringGroupIdList,
                      sequenceId: new Date().getTime()
                    };
                    gpsWS === null || gpsWS === void 0 ? void 0 : gpsWS.send(JSON.stringify(groupMsg));
                  }
                }
              }
            }
          }
        });
        var zoomListener = map.addListener("zoom_changed", function () {
          if (map.initialZoom === true) {
            var boundsListener = map.addListener("bounds_changed", function () {
              console.log("bounds_changed");
              if (map.getZoom() > initZoom) {
                // Change max/min zoom here
                map.setZoom(initZoom);
                map.initialZoom = false;
              }
              //@ts-ignore
              maps.event.removeListener(boundsListener);
            });
          }
        });
        var clickListener = map.addListener("click", function () {
          onSetInfoWindow === null || onSetInfoWindow === void 0 ? void 0 : onSetInfoWindow(undefined);
          setPrivateCamMarker(undefined);
        });
        return function () {
          //@ts-ignore
          maps.event.removeListener(zoomListener);
          maps.event.removeListener(clickListener);
          maps.event.removeListener(idleListener);
        };
      }
    }, [onSetInfoWindow, map, maps, bounds, mode, email, gpsWsReadyState, gpsWS, location, cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo]);
    (0, _react.useEffect)(function () {
      if (!location) {
        var _locationMarker$curre, _locationMarker$curre2, _locationMarker$curre3;
        (_locationMarker$curre = locationMarker.current) === null || _locationMarker$curre === void 0 || (_locationMarker$curre = _locationMarker$curre.main) === null || _locationMarker$curre === void 0 ? void 0 : _locationMarker$curre.setMap(null);
        (_locationMarker$curre2 = locationMarker.current) === null || _locationMarker$curre2 === void 0 || (_locationMarker$curre2 = _locationMarker$curre2.profile) === null || _locationMarker$curre2 === void 0 ? void 0 : _locationMarker$curre2.setMap(null);
        (_locationMarker$curre3 = locationMarker.current) === null || _locationMarker$curre3 === void 0 || (_locationMarker$curre3 = _locationMarker$curre3.label) === null || _locationMarker$curre3 === void 0 ? void 0 : _locationMarker$curre3.setMap(null);
        locationMarker.current = undefined;
        prevLocation.current = undefined;
      }
    }, [location]);
    (0, _react.useEffect)(function () {
      console.log("LocationMap", location, trackMarker, noMarker);
      if (map && maps && trackMarker && location) {
        if (prevLocation.current) {
          map.setCenter({
            lat: location.lat,
            lng: location.lng
          });
        } else {
          map.initialZoom = true;
          var lat = location.lat,
            lng = location.lng;
          map.setCenter({
            lat: lat,
            lng: lng
          });
          map.setZoom(21);
        }
        var labelText = (0, _pittaModules.getLocationLabel)(location, speedUnit !== null && speedUnit !== void 0 ? speedUnit : userSettings === null || userSettings === void 0 ? void 0 : userSettings.velocityUnit, true);
        if (!noMarker) {
          if (locationMarker.current) {
            var _locationMarker$curre4, _locationMarker$curre5;
            var _getSVGIcon3 = getSVGIcon(location, false, false, true, true, location.psn === (hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn)),
              width = _getSVGIcon3.width,
              height = _getSVGIcon3.height,
              svg = _getSVGIcon3.svg;
            (_locationMarker$curre4 = locationMarker.current) === null || _locationMarker$curre4 === void 0 || (_locationMarker$curre4 = _locationMarker$curre4.main) === null || _locationMarker$curre4 === void 0 ? void 0 : _locationMarker$curre4.setPosition(location);
            (_locationMarker$curre5 = locationMarker.current) === null || _locationMarker$curre5 === void 0 || (_locationMarker$curre5 = _locationMarker$curre5.main) === null || _locationMarker$curre5 === void 0 ? void 0 : _locationMarker$curre5.setIcon({
              anchor: new maps.Point(width / 2, height),
              size: new maps.Size(width, height),
              scaledSize: new maps.Size(width, height),
              url: svg
            });
            if (labelText) {
              var _locationMarker$curre6, _locationMarker$curre7;
              var labelWidth = labelText.width,
                labelHeight = labelText.height,
                _svg3 = labelText.svg,
                single = labelText.single;
              (_locationMarker$curre6 = locationMarker.current) === null || _locationMarker$curre6 === void 0 || (_locationMarker$curre6 = _locationMarker$curre6.label) === null || _locationMarker$curre6 === void 0 ? void 0 : _locationMarker$curre6.setPosition(location);
              (_locationMarker$curre7 = locationMarker.current) === null || _locationMarker$curre7 === void 0 || (_locationMarker$curre7 = _locationMarker$curre7.label) === null || _locationMarker$curre7 === void 0 ? void 0 : _locationMarker$curre7.setIcon({
                origin: new maps.Point(0, 0),
                anchor: new maps.Point(labelWidth / 2, single ? 26 : 36),
                size: new maps.Size(labelWidth, labelHeight),
                scaledSize: new maps.Size(labelWidth, labelHeight),
                url: _svg3
              });
            }
          } else {
            var label;
            if (labelText) {
              var _labelWidth2 = labelText.width,
                _labelHeight2 = labelText.height,
                _svg4 = labelText.svg,
                _single2 = labelText.single;
              label = new maps.Marker({
                position: location,
                map: map,
                zIndex: 2,
                icon: {
                  origin: new maps.Point(0, 0),
                  anchor: new maps.Point(_labelWidth2 / 2, _single2 ? 26 : 36),
                  size: new maps.Size(_labelWidth2, _labelHeight2),
                  scaledSize: new maps.Size(_labelWidth2, _labelHeight2),
                  url: _svg4
                }
              });
            }
            var _getSVGIcon4 = getSVGIcon(location, false, false, true, true, location.psn === (hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn)),
              _width2 = _getSVGIcon4.width,
              _height2 = _getSVGIcon4.height,
              _svg5 = _getSVGIcon4.svg;
            var main = new maps.Marker({
              position: location,
              map: map,
              icon: {
                anchor: new maps.Point(_width2 / 2, _height2),
                size: new maps.Size(_width2, _height2),
                scaledSize: new maps.Size(_width2, _height2),
                url: _svg5
              }
            });
            locationMarker.current = {
              main: main,
              label: label
            };
          }
        }
        prevLocation.current = location;
      }
    }, [trackMarker, location, map, maps, getSVGIcon, noMarker, userSettings, hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn, speedUnit]);
    (0, _react.useEffect)(function () {
      if (clusters && map && mode !== "liveview" && publicIcon) {
        var minLat = 999,
          minLng = 999,
          maxLat = -999,
          maxLng = -999;
        var ms = {};
        if (activePublic) {
          var _loop = function _loop() {
            var _clusters$zone2;
            var zone = (_clusters$zone2 = clusters.zone) === null || _clusters$zone2 === void 0 ? void 0 : _clusters$zone2[indx];
            if (zone) {
              var lat = parseFloat(zone.lat);
              var lng = parseFloat(zone.lng);
              var cnt = parseInt(zone.count);
              minLat = Math.min(minLat, lat);
              minLng = Math.min(minLng, lng);
              maxLat = Math.max(maxLat, lat);
              maxLng = Math.max(maxLng, lng);
              ms = _objectSpread(_objectSpread({}, ms), {}, _defineProperty({}, "zone-".concat(indx), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MarkerCluster, {
                key: "zone-".concat(indx),
                lat: lat,
                lng: lng,
                size: cnt < 100 ? "small" : "medium",
                variant: "outlined",
                label: zone.count,
                onClick: function onClick() {
                  map.setCenter({
                    lat: lat,
                    lng: lng
                  });
                  map.setZoom(map.getZoom() + 1);
                }
              })));
            }
          };
          for (var indx in (_clusters$zone = clusters.zone) !== null && _clusters$zone !== void 0 ? _clusters$zone : []) {
            var _clusters$zone;
            _loop();
          }
        }
        var _loop2 = function _loop2() {
          var _clusters$myzone2;
          var zone = (_clusters$myzone2 = clusters.myzone) === null || _clusters$myzone2 === void 0 ? void 0 : _clusters$myzone2[_indx];
          if (zone) {
            var lat = parseFloat(zone.lat);
            var lng = parseFloat(zone.lng);
            var cnt = parseInt(zone.count);
            minLat = Math.min(minLat, lat);
            minLng = Math.min(minLng, lng);
            maxLat = Math.max(maxLat, lat);
            maxLng = Math.max(maxLng, lng);
            ms = _objectSpread(_objectSpread({}, ms), {}, _defineProperty({}, "myzone-".concat(_indx), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MarkerCluster, {
              key: "myzone-".concat(_indx),
              lat: lat,
              lng: lng,
              size: cnt < 100 ? "small" : "medium",
              variant: "default",
              label: zone.count,
              style: {
                zIndex: 10
              },
              onClick: function onClick() {
                map.setCenter({
                  lat: lat,
                  lng: lng
                });
                map.setZoom(map.getZoom() + 1);
              }
            })));
          }
        };
        for (var _indx in (_clusters$myzone = clusters.myzone) !== null && _clusters$myzone !== void 0 ? _clusters$myzone : []) {
          var _clusters$myzone;
          _loop2();
        }
        setMarkers(ms);
      } else {
        setMarkers({});
      }
    }, [map, clusters, publicIcon, activePublic, mode]);
    (0, _react.useEffect)(function () {
      return function () {
        _lodash["default"].forEach(gMarkers.current, function (c) {
          var _c$profile, _c$label;
          c.main.setMap(null);
          (_c$profile = c.profile) === null || _c$profile === void 0 ? void 0 : _c$profile.setMap(null);
          (_c$label = c.label) === null || _c$label === void 0 ? void 0 : _c$label.setMap(null);
        });
        gMarkers.current = [];
        _lodash["default"].forEach(publicMarkers.current, function (m) {
          var _m$profile2, _m$label2;
          m.main.setMap(null);
          (_m$profile2 = m.profile) === null || _m$profile2 === void 0 ? void 0 : _m$profile2.setMap(null);
          (_m$label2 = m.label) === null || _m$label2 === void 0 ? void 0 : _m$label2.setMap(null);
        });
        publicMarkers.current = [];
      };
    }, []);
    (0, _react.useEffect)(function () {
      if (!activePublic) {
        _lodash["default"].forEach(publicMarkers.current, function (m) {
          var _m$profile3, _m$label3;
          m.main.setMap(null);
          (_m$profile3 = m.profile) === null || _m$profile3 === void 0 ? void 0 : _m$profile3.setMap(null);
          (_m$label3 = m.label) === null || _m$label3 === void 0 ? void 0 : _m$label3.setMap(null);
        });
        publicMarkers.current = [];
      }
    }, [activePublic]);
    (0, _react.useEffect)(function () {
      if (webPushEvent && maps) {
        var current = gMarkers.current;
        var found = _lodash["default"].find(current, function (loc) {
          return loc.psn === webPushEvent.psn;
        });
        if (found) {
          found.event = webPushEvent;
          found.main.setClickable(true);
          found.main.addListener("click", function () {
            onLiveView === null || onLiveView === void 0 ? void 0 : onLiveView(found.psn, false);
            //팝업 열어주는 코드
            // setSelectedMarker(found);
          });

          var timerId = setInterval(function () {
            var _getSVGIcon5 = getSVGIcon(found.loc, found.isEvent, false, false, false, found.loc.psn === (hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn)),
              width = _getSVGIcon5.width,
              height = _getSVGIcon5.height,
              svg = _getSVGIcon5.svg;
            // 10371 - 마커 위치 문제 수정 (mckim)
            found.main.setIcon({
              anchor: new maps.Point(width / 2, height),
              size: new maps.Size(width, height),
              scaledSize: new maps.Size(width, height),
              url: svg
            });
            found.isEvent = !found.isEvent;
          }, 500);
          return function () {
            found.isEvent = false;
            clearInterval(timerId);
          };
          // setSelectedMarker(found);
        }
      } else {
        // setSelectedMarker(undefined);
      }
    }, [getSVGIcon, hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn, maps, onLiveView, webPushEvent]);
    (0, _react.useEffect)(function () {
      //라이브뷰 랜더링
      if (locations && map && maps && (noCluster || mode === "liveview" || !initMap)) {
        var filteredLocations = _lodash["default"].filter(locations, function (loc) {
          return loc.agree_gps === "on" || loc.isPublic;
        });
        var current = gMarkers.current;
        var psns = _lodash["default"].map(filteredLocations, function (loc) {
          return loc.psn;
        });
        var filteredPsns = _lodash["default"].map(filteredCams, function (cam) {
          return cam.psn;
        });
        var removed = _lodash["default"].filter(current, function (loc) {
          var l = _lodash["default"].find(filteredLocations, function (ll) {
            return ll.psn === loc.psn;
          });
          if (l) {
            return !_lodash["default"].includes(psns, loc.psn) || filteredCams && !_lodash["default"].includes(filteredPsns, loc.psn) || l.lat === 0 || l.lng === 0;
          }
          return true;
        });
        var updated = _lodash["default"].filter(current, function (loc) {
          var l = _lodash["default"].find(filteredLocations, function (ll) {
            return ll.psn === loc.psn;
          });
          if (l) {
            return _lodash["default"].includes(psns, loc.psn) && (!filteredCams || _lodash["default"].includes(filteredPsns, loc.psn)) && !(l.lat === 0 || l.lng === 0);
          }
          return false;
        });

        // console.log(
        //   "CloudNative3",
        //   "gMarkers.current",
        //   gMarkers.current,
        //   "psns",
        //   psns,
        //   "locations",
        //   locations,
        //   "filteredCams",
        //   filteredCams,
        //   "filteredLocations",
        //   filteredLocations,
        //   "removed",
        //   removed,
        //   "updated",
        //   updated
        // );

        _lodash["default"].forEach(removed, function (r) {
          var _r$profile, _r$label;
          r.main.setMap(null);
          (_r$profile = r.profile) === null || _r$profile === void 0 ? void 0 : _r$profile.setMap(null);
          (_r$label = r.label) === null || _r$label === void 0 ? void 0 : _r$label.setMap(null);
        });
        var needToUpdate = false;
        var ms = _lodash["default"].chain(filteredLocations).filter(function (loc) {
          return (filteredCams ? _lodash["default"].includes(filteredPsns, loc.psn) : true) && !(loc.lat === 0 || loc.lng === 0);
        }).map(function (loc, indx) {
          var found = _lodash["default"].find(updated, function (c) {
            return c.psn === loc.psn;
          });
          var isPublic = !!_lodash["default"].find(publicCams, function (c) {
            return c.psn === loc.psn;
          });
          var labelText = (0, _pittaModules.getLocationLabel)(loc, speedUnit !== null && speedUnit !== void 0 ? speedUnit : userSettings === null || userSettings === void 0 ? void 0 : userSettings.velocityUnit, mode === "liveview");
          if (found) {
            var _found$main, _found$main2, _found$profile4;
            var _getSVGIcon6 = getSVGIcon(loc, found.isEvent, isPublic, mode === "liveview", mode === "liveview", mode !== "liveview" && loc.psn === (hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn)),
              width = _getSVGIcon6.width,
              height = _getSVGIcon6.height,
              svg = _getSVGIcon6.svg;
            (_found$main = found.main) === null || _found$main === void 0 ? void 0 : _found$main.setPosition({
              lat: loc.lat,
              lng: loc.lng
            });
            (_found$main2 = found.main) === null || _found$main2 === void 0 ? void 0 : _found$main2.setIcon({
              anchor: new maps.Point(width / 2, height),
              size: new maps.Size(width, height),
              scaledSize: new maps.Size(width, height),
              url: svg
            });
            // mantis - 10822, 공유캠에는 P라벨 나오고 my cam에는 나오지 않도록 && !isPublic 조건 추가(Leehj)
            if (mode === "liveview" && loc.mode === "1" && !isPublic) {
              var _found$label4;
              (_found$label4 = found.label) === null || _found$label4 === void 0 ? void 0 : _found$label4.setMap(null);
              found.label = undefined;
            } else if (labelText) {
              var labelWidth = labelText.width,
                labelHeight = labelText.height,
                single = labelText.single,
                lineSvg = labelText.svg;
              if (found.label) {
                var _found$label5, _found$label6;
                (_found$label5 = found.label) === null || _found$label5 === void 0 ? void 0 : _found$label5.setPosition({
                  lat: loc.lat,
                  lng: loc.lng
                });
                (_found$label6 = found.label) === null || _found$label6 === void 0 ? void 0 : _found$label6.setIcon({
                  origin: new maps.Point(0, 0),
                  // mantis - 10204, 라이브 뷰 공유된 카메라 labelText위치수정. (Leehj)
                  // 10487 높이 수정 (mckim)
                  anchor: new maps.Point(labelWidth / 2, isPublic ? 32 : single ? 26 : 36),
                  size: new maps.Size(labelWidth, labelHeight),
                  scaledSize: new maps.Size(labelWidth, labelHeight),
                  url: lineSvg
                });
              } else {
                found.label = new maps.Marker({
                  position: {
                    lat: loc.lat,
                    lng: loc.lng
                  },
                  map: map,
                  zIndex: 60000 + indx * 3 + 2,
                  icon: {
                    origin: new maps.Point(0, 0),
                    // 10487 높이 수정 (mckim)
                    anchor: new maps.Point(labelWidth / 2, isPublic ? 32 : single ? 26 : 36),
                    size: new maps.Size(labelWidth, labelHeight),
                    scaledSize: new maps.Size(labelWidth, labelHeight),
                    url: lineSvg
                  }
                });
              }
            }
            (_found$profile4 = found.profile) === null || _found$profile4 === void 0 ? void 0 : _found$profile4.setPosition({
              lat: loc.lat,
              lng: loc.lng
            });
            // if (!isEvent) {
            //   found.setClickable(false);
            //   // found.setAnimation(null);
            //   maps.event.clearListeners(found, "click");
            //   found.event = undefined;
            // }
            found.loc = loc;
            return found;
          } else {
            needToUpdate = true;
            var label;
            var _getSVGIcon7 = getSVGIcon(loc, false, isPublic, mode === "liveview", mode === "liveview", mode !== "liveview" && loc.psn === (hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn)),
              _width3 = _getSVGIcon7.width,
              _height3 = _getSVGIcon7.height,
              _svg6 = _getSVGIcon7.svg;
            // 10487 - 파킹모드 라이브뷰에서는 하단 라벨 표시 안함 (mckim)
            if (labelText && !(mode === "liveview" && loc.mode === "1" && !isPublic)) {
              var _labelWidth3 = labelText.width,
                _labelHeight3 = labelText.height,
                _single3 = labelText.single,
                labelSvg = labelText.svg;
              label = new maps.Marker({
                position: {
                  lat: loc.lat,
                  lng: loc.lng
                },
                map: map,
                zIndex: 60000 + indx * 3 + 2,
                icon: {
                  origin: new maps.Point(0, 0),
                  // 10487 높이 수정 (mckim)
                  anchor: new maps.Point(_labelWidth3 / 2, isPublic ? 32 : _single3 ? 26 : 36),
                  size: new maps.Size(_labelWidth3, _labelHeight3),
                  scaledSize: new maps.Size(_labelWidth3, _labelHeight3),
                  url: labelSvg
                }
              });
            }
            var marker = new maps.Marker({
              position: {
                lat: loc.lat,
                lng: loc.lng
              },
              map: map,
              zIndex: 60000 + indx * 3,
              icon: {
                origin: new maps.Point(0, 0),
                anchor: new maps.Point(_width3 / 2, _height3),
                size: new maps.Size(_width3, _height3),
                scaledSize: new maps.Size(_width3, _height3),
                url: _svg6
              }
            });
            var profile = isPublic ? new maps.Marker({
              position: {
                lat: loc.lat,
                lng: loc.lng
              },
              map: map,
              zIndex: 60000 + indx * 3 + 1,
              icon: {
                origin: new maps.Point(0, 0),
                size: new maps.Size(42, 42),
                // mantis - 10204, 라이브 뷰 공유된 카메라 사이즈 24*24로 수정 및 위치수정. (Leehj)
                scaledSize: new maps.Size(24, 24),
                anchor: new maps.Point(12, 48.5),
                // scaledSize: new maps.Size(42, 42),
                // anchor: new maps.Point(21, 60.5),
                url: loc.profile_img
              },
              title: "profile"
            }) : undefined;
            if (loc.active === "on") {
              marker.addListener("click", function () {
                onLiveView === null || onLiveView === void 0 ? void 0 : onLiveView(loc.psn, false);
              });
            }
            return {
              main: marker,
              profile: profile,
              label: label,
              loc: loc,
              psn: loc.psn,
              model: loc.model
            };
          }
        }).value();

        // console.log(
        //   "CloudNative3",
        //   "LocationMap",
        //   "neddToUpdate",
        //   needToUpdate,
        //   "disableAutoZoom",
        //   disableAutoZoom,
        //   "initMap",
        //   initMap
        // );
        if (needToUpdate && (!disableAutoZoom || mode === "liveview" && filteredLocations.length === 1 || !initMap)) {
          console.log("autoZoom!!!");
          var minLat = 999,
            minLng = 999,
            maxLat = -999,
            maxLng = -999;
          _lodash["default"].forEach(ms, function (m) {
            var _m$loc = m.loc,
              lat = _m$loc.lat,
              lng = _m$loc.lng;
            minLat = Math.min(lat, minLat);
            minLng = Math.min(lng, minLng);
            maxLat = Math.max(lat, maxLat);
            maxLng = Math.max(lng, maxLng);
          });
          map.initialZoom = true;
          map.fitBounds({
            east: maxLng,
            north: maxLat,
            west: minLng,
            south: minLat
          });
          setInitMap(true);
        }
        gMarkers.current = ms;
      } else {
        var _current = gMarkers.current;
        _lodash["default"].forEach(_current, function (m) {
          var _m$main, _m$profile4, _m$label4;
          (_m$main = m.main) === null || _m$main === void 0 ? void 0 : _m$main.setMap(null);
          (_m$profile4 = m.profile) === null || _m$profile4 === void 0 ? void 0 : _m$profile4.setMap(null);
          (_m$label4 = m.label) === null || _m$label4 === void 0 ? void 0 : _m$label4.setMap(null);
        });
        gMarkers.current = [];
      }
    }, [disableAutoZoom, filteredCams, getSVGIcon, hoveredLoc === null || hoveredLoc === void 0 ? void 0 : hoveredLoc.psn, initMap, locations, map, maps, mode, noCluster, onLiveView, publicCams, speedUnit, userSettings, webPushEvent]);
    var browserName = (0, _react.useMemo)(function () {
      var _detect;
      return (_detect = (0, _detectBrowser.detect)()) === null || _detect === void 0 ? void 0 : _detect.name;
    }, []);
    var handleFullscreen = (0, _react.useCallback)(function () {
      if (iosBrowser) {
        setfullscreen(function (f) {
          return !f;
        });
      } else {
        var _mapRef$current;
        var elementToSendFullscreen = (_mapRef$current = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) !== null && _mapRef$current !== void 0 ? _mapRef$current : mapDivRef.current;
        if (elementToSendFullscreen) {
          (0, _pittaModules.toggleFullscreen)(elementToSendFullscreen);
          //@ts-ignore
          setfullscreen(elementToSendFullscreen.fullscreen);
          //@ts-ignore
          onSetFullScreen(elementToSendFullscreen.fullscreen);
          if (app) {
            //@ts-ignore
            if (elementToSendFullscreen.fullscreen) {
              var _window$Webviewer;
              if (browserName === "ios-webview" &&
              //@ts-ignore
              webkit.messageHandlers.enableRotate) {
                //@ts-ignore
                webkit.messageHandlers.enableRotate.postMessage({});
              }
              if (browserName === "chromium-webview" && //@ts-ignore
              (_window$Webviewer = window.Webviewer) !== null && _window$Webviewer !== void 0 && _window$Webviewer.enableRotate) {
                var _window$Webviewer2, _window$Webviewer2$en;
                //@ts-ignore
                (_window$Webviewer2 = window.Webviewer) === null || _window$Webviewer2 === void 0 || (_window$Webviewer2$en = _window$Webviewer2.enableRotate) === null || _window$Webviewer2$en === void 0 ? void 0 : _window$Webviewer2$en.call(_window$Webviewer2);
              }
            } else {
              var _window$Webviewer3;
              if (browserName === "ios-webview" &&
              //@ts-ignore
              webkit.messageHandlers.disableRotate) {
                //@ts-ignore
                webkit.messageHandlers.disableRotate.postMessage({});
              }
              if (browserName === "chromium-webview" && //@ts-ignore
              (_window$Webviewer3 = window.Webviewer) !== null && _window$Webviewer3 !== void 0 && _window$Webviewer3.disableRotate) {
                var _window$Webviewer4, _window$Webviewer4$di;
                //@ts-ignore
                (_window$Webviewer4 = window.Webviewer) === null || _window$Webviewer4 === void 0 || (_window$Webviewer4$di = _window$Webviewer4.disableRotate) === null || _window$Webviewer4$di === void 0 ? void 0 : _window$Webviewer4$di.call(_window$Webviewer4);
              }
            }
          }
        }
      }
    }, [app, browserName, iosBrowser, mapRef]);
    var mapTopRightMenuMarkup = (0, _react.useMemo)(function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.topControlPane
      }, /*#__PURE__*/_react["default"].createElement(_TopRightControl.TopRightControl, {
        round: true
        // ref={anchorRef}
        // mantis - 12433, Map Type 선택 시 팝업 미노출 이슈 수정, layerRef에 값 적용 (Leehj)
        ,
        layerRef: anchorRef,
        publicRef: publicRef,
        onFullscreen: fullscreenIcon ? handleFullscreen : undefined,
        onLayers: function onLayers() {
          return setOpenLayer(function (o) {
            return !o;
          });
        },
        onDashcamPublic: publicIcon ? function () {
          setOpenCamFilter(function (o) {
            return !o;
          });
        } : undefined,
        fullscreen: fullscreen,
        activePublic: activePublic,
        t: t
      }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Menu, {
        open: openCamFilter,
        onClickAway: function onClickAway() {
          return setOpenCamFilter(false);
        },
        anchorEl: publicRef.current
        // mantis - 10778, 모바일 피그마 적용 (Leehj)
        ,
        placement: smallMobileSize ? "bottom" : "bottom-end",
        modifiers: {
          offset: {
            enabled: true,
            // mantis - 10778, 모바일 피그마 적용 및 잘려보이는 것 방지하기 위한 위치 조정 (Leehj)
            offset: iphoneSEMobileSize ? "-40px, 4px" : xsmallMobileSize ? "-50px, 4px" : smallMobileSize ? "-65px, 4px" : "0, 4px"
          },
          preventOverflow: {
            enabled: false
          }
        },
        classes: {
          root: classes.camFilterRoot
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.camFilterDiv
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.camFilterTitle
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "SmallBold",
        htmlColor: _pittaModules.LightColors.primary["7"]
      }, t("Public"))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.camFilterListItem
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "Body"
      }, t("BlackVue Live Camera")), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Switch, {
        checked: activePublic,
        onChange: function onChange(_e, checked) {
          setActivePublic(checked);
        }
      }))))), !mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Menu, {
        open: openLayer,
        onClickAway: function onClickAway() {
          return setOpenLayer(false);
        },
        anchorEl: anchorRef.current,
        placement: "bottom-end",
        modifiers: {
          offset: {
            enabled: true,
            offset: "0, 4px"
          },
          preventOverflow: {
            enabled: false
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
        className: (0, _clsx5["default"])(_defineProperty({}, classes.tnpDiv, mapMode === "satellite")),
        startIcon: mapMode === "map" && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          className: classes.appIcon
        }),
        onClick: function onClick() {
          setMapMode("map");
          map === null || map === void 0 ? void 0 : map.setMapTypeId("roadmap");
          setOpenLayer(false);
        }
      }, t("Map")), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
        className: (0, _clsx5["default"])(_defineProperty({}, classes.tnpDiv, mapMode === "map")),
        startIcon: mapMode === "satellite" && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          className: classes.appIcon
        }),
        onClick: function onClick() {
          setMapMode("satellite");
          map === null || map === void 0 ? void 0 : map.setMapTypeId("satellite");
          setOpenLayer(false);
        }
      }, t("Satellite"))), mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MobileMenu, {
        open: openLayer,
        onClose: function onClose() {
          return setOpenLayer(false);
        },
        container: anchorRef.current,
        classes: {
          root: classes.textTransform
        }
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
        className: classes.mobileMemuItem,
        endIcon: mapMode === "map" && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          className: classes.appIcon
        }),
        onClick: function onClick() {
          setMapMode("map");
          map === null || map === void 0 ? void 0 : map.setMapTypeId("roadmap");
          setOpenLayer(false);
        }
      }, t("Map")), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
        className: classes.mobileMemuItem,
        endIcon: mapMode === "satellite" && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          className: classes.appIcon
        }),
        onClick: function onClick() {
          setMapMode("satellite");
          map === null || map === void 0 ? void 0 : map.setMapTypeId("satellite");
          setOpenLayer(false);
        }
      }, t("Satellite"))));
    }, [classes.topControlPane, classes.camFilterRoot, classes.camFilterDiv, classes.camFilterTitle, classes.camFilterListItem, classes.tnpDiv, classes.appIcon, classes.textTransform, classes.mobileMemuItem, fullscreenIcon, handleFullscreen, publicIcon, fullscreen, activePublic, openCamFilter, smallMobileSize, iphoneSEMobileSize, xsmallMobileSize, t, mobile, openLayer, mapMode, map]);
    var zoomPanelMarkup = (0, _react.useMemo)(function () {
      var _t, _clsx3, _t2, _t3;
      return (
        /*#__PURE__*/
        // mantis - 9061, touch이벤트 사용하여 모바일의경우 touch한 경우에만 아이콘 색 변경되도록 수정.(Leehj)
        _react["default"].createElement("div", {
          className: classes.zoomControlDiv,
          onTouchStart: function onTouchStart() {
            return setTouch(true);
          },
          onTouchEnd: function onTouchEnd() {
            return setTouch(false);
          }
        }, showLocation && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
          placement: "left",
          disableTouchListener: mobile,
          title: (_t = t("My location")) !== null && _t !== void 0 ? _t : "My location",
          PopperProps: {
            disablePortal: true,
            modifiers: {
              preventOverflow: {
                enabled: false
              },
              flip: {
                enabled: false
              }
            }
          }
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
          size: "small",
          variant: "rounded",
          className: (0, _clsx5["default"])(classes.zoomControlBtn, classes.gpsFixBtn, (_clsx3 = {}, _defineProperty(_clsx3, classes.gpsFixBtnTouch, touch), _defineProperty(_clsx3, classes.noHover, mobile), _clsx3)),
          onClick: function onClick() {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function (position) {
                var pos = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                };
                map.setCenter(pos);
              }, function () {});
            }
          }
        }, /*#__PURE__*/_react["default"].createElement(_GpsFixed["default"], {
          fontSize: "small"
        }))), !mobile && /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            borderRadius: 8,
            boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)"
          }
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
          title: (_t2 = t("Zoom in")) !== null && _t2 !== void 0 ? _t2 : "Zoom in",
          PopperProps: {
            disablePortal: true,
            modifiers: {
              preventOverflow: {
                enabled: false
              },
              flip: {
                enabled: false
              }
            },
            placement: theme.direction === "rtl" ? "right" : "left"
          }
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
          size: "small",
          variant: "rounded",
          className: (0, _clsx5["default"])(classes.zoomControlBtn, classes.zoomInBtn),
          onClick: function onClick() {
            map.setZoom(map.getZoom() + 1);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Add["default"], {
          fontSize: "small"
        }))), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
          title: (_t3 = t("Zoom out")) !== null && _t3 !== void 0 ? _t3 : "Zoom out",
          PopperProps: {
            disablePortal: true,
            modifiers: {
              preventOverflow: {
                enabled: false
              },
              flip: {
                enabled: false
              }
            },
            placement: theme.direction === "rtl" ? "right" : "left"
          }
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
          size: "small",
          variant: "rounded",
          className: (0, _clsx5["default"])(classes.zoomControlBtn, classes.zoomOutBtn),
          onClick: function onClick() {
            map.setZoom(map.getZoom() - 1);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Remove["default"], {
          fontSize: "small"
        })))))
      );
    }, [classes.zoomControlDiv, classes.zoomControlBtn, classes.gpsFixBtn, classes.gpsFixBtnTouch, classes.noHover, classes.zoomInBtn, classes.zoomOutBtn, showLocation, mobile, t, touch, theme.direction, map]);
    var infoWindow = (0, _react.useMemo)(function () {
      if (selectedMarker && selectedMarker.event) {
        var latLng = selectedMarker.getPosition();
        console.log("renderInfoWindow", latLng, selectedMarker.event);
        return /*#__PURE__*/_react["default"].createElement("div", {
          //@ts-ignore
          lat: latLng.lat()
          //@ts-ignore
          ,
          lng: latLng.lng(),
          className: (0, _clsx5["default"])(classes.infoWindowDiv, classes.infoWindowCenter, classes.parkingDiv)
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.EventCard, {
          event: selectedMarker.event,
          fileType: "Event",
          model: selectedMarker.model,
          onClose: function onClose() {
            return setSelectedMarker(undefined);
          }
        }));
      }
      return undefined;
    }, [classes.infoWindowCenter, classes.infoWindowDiv, classes.parkingDiv, selectedMarker]);
    var privateCamWindow = (0, _react.useMemo)(function () {
      if (privateCamMarker) {
        var found = _lodash["default"].find(publicCams, function (cam) {
          return cam.psn === privateCamMarker.psn;
        });
        console.log("found", found);
        if (found) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            //@ts-ignore
            lat: found.lat
            //@ts-ignore
            ,
            lng: found.lng,
            className: (0, _clsx5["default"])(classes.parkingDiv, classes.privateCamWindowCenter, classes.privateCamDiv)
          }, t("This camera is publicly_"));
        }
      }
      return undefined;
    }, [classes.parkingDiv, classes.privateCamDiv, classes.privateCamWindowCenter, privateCamMarker, publicCams, t]);
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: fullscreen ? mapRef !== null && mapRef !== void 0 ? mapRef : mapDivRef : mapDivRef,
      style: {
        width: "100%",
        height: "100%"
      },
      className: (0, _clsx5["default"])(_defineProperty({}, classes.rootFullscreen, fullscreen))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: "100%",
        height: "100%",
        position: "relative"
      }
    }, /*#__PURE__*/_react["default"].createElement(_googleMapReact["default"], {
      style: {
        width: "100%",
        height: "100%",
        //@ts-ignore
        position: "relative",
        touchAction: "none"
      },
      bootstrapURLKeys: {
        key: _pittaModules.GOOGLE_API_KEY,
        libraries: ["geometry", "drawing"]
      },
      defaultCenter: _pittaModules.INITIAL_MAP_LOCATION,
      defaultZoom: 4
      //지도에서 bus stop 클릭되는 문제 수정 (8356)
      ,
      options: {
        disableDefaultUI: true,
        clickableIcons: false
      },
      yesIWantToUseGoogleMapApiInternals: true,
      onGoogleApiLoaded: function onGoogleApiLoaded(_ref) {
        var maps = _ref.maps,
          map = _ref.map,
          ref = _ref.ref;
        setMap(map);
        setMaps(maps);
        _onGoogleApiLoaded === null || _onGoogleApiLoaded === void 0 ? void 0 : _onGoogleApiLoaded({
          maps: maps,
          map: map,
          ref: ref
        });
      }
      // onChange={(value) => console.log(value)}
    }, _lodash["default"].values(markers), children, selectedMarker && infoWindow, privateCamMarker && privateCamWindow), mapTopRightMenuMarkup, zoomPanelMarkup));
  });
  _exports.LocationMap = LocationMap;
});